import React from 'react';
import Hosmus from './Hosmus/Hosmus';

import './App.scss';



export default function App() {
  return (
    <div className="palette-generator-app">
      <Hosmus/>
    </div>
  );

};
